import { render, staticRenderFns } from "./RankHistory.vue?vue&type=template&id=226f51e2&scoped=true&lang=pug&"
import script from "./scripts/RankHistory.js?vue&type=script&lang=js&"
export * from "./scripts/RankHistory.js?vue&type=script&lang=js&"
import style0 from "./RankHistory.vue?vue&type=style&index=0&id=226f51e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f51e2",
  null
  
)

export default component.exports